export default {
    computed: {
        currentUrlEventId () {
            const matches = window.location.pathname.match(/\/events\/(\d*?)(\/.*)?$/);

            return matches ? Number(matches[1]) : null;
        }
    }
};
